<template>
  <v-card v-if="items.length" class="mention-suggestion-list" elevation="4" max-width="320">
    <v-list dense class="py-0">
      <v-list-item
        v-for="(item, index) in items"
        :key="item.id"
        :class="{ 'v-list-item--active primary--text': index === selectedIndex }"
        @click="selectItem(index)"
        @mouseenter="selectedIndex = index"
      >
        <v-list-item-icon v-if="item.icon" class="mr-2 my-auto">
          <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-body-2" :class="{ 'mention-archived': item.isArchived }">
            {{ item.label }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.subtitle" class="text-caption">
            {{ item.subtitle }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SuggestionItem } from "./suggestion-renderer";

@Component({})
export default class MentionSuggestionList extends Vue {
  @Prop({ default: () => [] })
  items!: SuggestionItem[];

  @Prop({ required: true })
  command!: (item: SuggestionItem) => void;

  selectedIndex = 0;

  @Watch("items")
  onItemsChange() {
    this.selectedIndex = 0;
  }

  selectItem(index: number) {
    const item = this.items[index];
    if (item) {
      this.command(item);
    }
  }

  onKeyDown(event: KeyboardEvent): boolean {
    if (!this.items.length) return false;

    if (event.key === "ArrowUp") {
      this.selectedIndex = (this.selectedIndex + this.items.length - 1) % this.items.length;
      return true;
    }

    if (event.key === "ArrowDown") {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
      return true;
    }

    if (event.key === "Enter" || event.key === "Tab") {
      this.selectItem(this.selectedIndex);
      return true;
    }

    return false;
  }
}
</script>

<style scoped>
.mention-suggestion-list {
  overflow: auto;
  max-height: 240px;
  font-family: "Roboto", sans-serif;
}

.mention-archived {
  text-decoration: line-through;
  opacity: 0.5;
}
</style>
